export default "__VITE_ASSET__BHX12n8x__"